import { render, staticRenderFns } from "./PigEcharts.vue?vue&type=template&id=3f89c2da&scoped=true"
import script from "./PigEcharts.vue?vue&type=script&lang=js"
export * from "./PigEcharts.vue?vue&type=script&lang=js"
import style0 from "./PigEcharts.vue?vue&type=style&index=0&id=3f89c2da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f89c2da",
  null
  
)

export default component.exports